<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/136ckux/tc-custom/9781612541228.jpg?1737684775584" alt="This image is the cover for the book Others, SCOPE of Leadership Book Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Others, SCOPE of Leadership Book Series
      </h1>
      <p class="bookDescription body article font2">
        <b>Focus on supporting and coaching employees with the third book in the “most comprehensive treatment of leadership I’ve ever seen by one author” (Jim Kouzes, coauthor of <i>The Leadership Challenge</i>).</b><br/><br/><i>Others: Developing People</i> guides you in building the skills of others and developing top performers. Great leaders build teams of competent people who are able and willing to take ownership for the work that needs to be performed. By learning the competencies of coaching, enabling, and holding people accountable, you multiply your abilities, transfer your knowledge, and leave an enduring legacy.<br/><br/>The SCOPE of Leadership book series teaches the principles of a coaching approach to leadership and how to achieve exceptional results by working through people. You will learn a straightforward framework to guide you in developing, enabling, exhorting, inspiring, managing, and assimilating people. Benefit from the wisdom of many years of leadership, consulting, and executive coaching experience. Discover how to develop the competencies that align consistently with great leadership.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mike Hawkins
      </h2>
      
      <p class="authorDescription body article">Mike Hawkins is the award-winning author of Activating Your Ambition: A Guide to Coaching the Best Out of Yourself and Others, a seasoned executive coach, and an expert in improving organizational performance. He is president of Alpine Link Corporation, where he is a respected practitioner, speaker, and thought leader on leadership, self-improvement, and business improvement. He is known for consistently leading organizations and individuals to higher levels of achievement. Prior to founding Alpine Link, Mike developed his practical perspectives on leadership through his unique combination of experience in engineering, sales, and senior management. He has a rare blend of technical, operational, and leadership knowledge. Throughout Mike's career, he has accepted the toughest assignments and excelled in overcoming the most challenging issues. Few people have practiced, studied, and coached on the topic of leadership to the extent that he has. As a result, Mike has developed and refined numerous frameworks including the SCOPE of Leadership™, Activating Your Ambition™, and Peak Potential Selling™ to help organizations and individuals break through their limitations and achieve higher levels of success.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Brown Books Publishing Group
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5629b6bb